var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3986 5.83175V9.5978L14.8992 11.8162C14.9593 11.905 14.994 12.0084 14.9993 12.1155C15.0046 12.2226 14.9802 12.3289 14.9291 12.4232C14.8779 12.5174 14.802 12.5957 14.7098 12.6502L14.5781 12.7078H1.42187C1.37605 12.694 1.33183 12.6747 1.29024 12.6502C1.19797 12.5957 1.12206 12.5174 1.07091 12.4232C1.01976 12.3289 0.995427 12.2226 1.00071 12.1155C1.00599 12.0084 1.0407 11.9049 1.1008 11.8162L2.6014 9.5978V5.83174C2.6014 3.38119 4.28049 1.31855 6.5624 0.698978C7.30602 0.562707 7.6539 0.5 7.99999 0.5C8.34606 0.5 8.69394 0.562701 9.43748 0.698957C10.5739 1.00893 11.5768 1.67728 12.2924 2.60259C13.0097 3.53023 13.3985 4.66469 13.3986 5.83175ZM13.2895 11.5552L12.3091 10.1054C12.2438 10.0085 12.2089 9.89398 12.2091 9.77705V5.83174C12.2091 4.73325 11.7663 3.67918 10.9773 2.90157C10.1882 2.12386 9.11727 1.68642 7.99999 1.68642C6.88273 1.68642 5.8118 2.12386 5.02269 2.90157C4.23366 3.67918 3.79092 4.73325 3.79092 5.83174V9.77709C3.79095 9.89406 3.75577 10.0082 3.69022 10.1051L2.70968 11.5552H13.2895Z",
    fill: "#4E4E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47843 13.728C5.62387 14.1705 5.88958 14.5681 6.24998 14.8757C6.72217 15.2786 7.32535 15.5 7.94893 15.5C8.57254 15.5 9.17571 15.2786 9.64789 14.8757C10.0083 14.5681 10.274 14.1705 10.4195 13.728H9.10488C9.01242 13.8589 8.89702 13.974 8.76305 14.0675C8.52541 14.2332 8.24111 14.3224 7.94935 14.3224C7.65757 14.3224 7.37329 14.2332 7.13564 14.0675C7.00167 13.9741 6.88627 13.8589 6.7938 13.728H5.47843Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ce0c2a7964745d575add57b12f8c5455.svg";
export { ForwardRef as ReactComponent };